import { render } from "./ForumsView.vue?vue&type=template&id=a4e8461e"
import script from "./ForumsView.vue?vue&type=script&lang=js"
export * from "./ForumsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__